export const PERMISSIONS_MAP = {
  ADMIN: { apiKey: "admin", label: "Administrateur" },
  CENTRE_ACCESS: { apiKey: "centre.access", label: "Identification du Centre - Accès module" },
  CENTRE_INFO_VIEW: {
    apiKey: "centre.info.view",
    label: "Identification du Centre - Infos - Voir",
  },
  CENTRE_INFO_EDIT: {
    apiKey: "centre.info.edit",
    label: "Identification du Centre - Infos - Éditer",
  },
  CENTRE_DEVICES_VIEW: {
    apiKey: "centre.devices.view",
    label: "Identification du Centre - Appareils - Voir",
  },
  CENTRE_DEVICES_PAIR: {
    apiKey: "centre.devices.pair",
    label: "Identification du Centre - Appareils - Appairer",
  },
  CENTRE_DEVICES_REVOKE: {
    apiKey: "centre.devices.revoke",
    label: "Identification du Centre - Appareils - Supprimer",
  },
  USERS_ACCESS: { apiKey: "users.access", label: "Utilisateurs - Accès module" },
  USERS_ALL_VIEW: { apiKey: "users.all.view", label: "Utilisateurs - Tous - Voir" },
  USERS_ALL_EDIT: { apiKey: "users.all.edit", label: "Utilisateurs - Tous - Éditer" },
  USERS_COMPANY_VIEW: { apiKey: "users.company.view", label: "Utilisateurs - Ma société - Voir" },
  USERS_COMPANY_EDIT: { apiKey: "users.company.edit", label: "Utilisateurs - Ma société - Éditer" },
  USERS_ROLES_VIEW: { apiKey: "users.roles.view", label: "Utilisateurs - Rôles - Voir" },
  USERS_ROLES_EDIT: { apiKey: "users.roles.edit", label: "Utilisateurs - Rôles - Éditer" },
  USERS_DOCUMENTS_VIEW: {
    apiKey: "users.documents.view",
    label: "Utilisateurs - Documents - Voir",
  },
  USERS_DOCUMENTS_EDIT: {
    apiKey: "users.documents.edit",
    label: "Utilisateurs - Documents - Éditer",
  },
  USERS_OWN_VIEW: { apiKey: "users.own.view", label: "Utilisateurs - Mon compte - Voir" },
  USERS_OWN_EDIT: { apiKey: "users.own.edit", label: "Utilisateurs - Mes documents - Éditer" },
  COMMUNICATION_ACCESS: { apiKey: "communication.access", label: "Communication - Accès module" },
  COMMUNICATION_MAIL_TEMPLATES_VIEW: {
    apiKey: "communication.mail_templates.view",
    label: "Communication - Modèles d'emails - Voir",
  },
  COMMUNICATION_MAIL_TEMPLATES_EDIT: {
    apiKey: "communication.mail_templates.edit",
    label: "Communication - Modèles d'emails - Éditer",
  },
  COMMUNICATION_SMS_TEMPLATES_VIEW: {
    apiKey: "communication.sms_templates.view",
    label: "Communication - Modèles SMS - Voir",
  },
  COMMUNICATION_SMS_TEMPLATES_EDIT: {
    apiKey: "communication.sms_templates.edit",
    label: "Communication - Modèles SMS - Éditer",
  },
  COMMUNICATION_GOOGLE_GROUPS_VIEW: {
    apiKey: "communication.google_groups.view",
    label: "Communication - Google Groups - Voir",
  },
  COMMUNICATION_GOOGLE_GROUPS_EDIT: {
    apiKey: "communication.google_groups.edit",
    label: "Communication - Google Groups - Éditer",
  },
  COMMUNICATION_SETTINGS_VIEW: {
    apiKey: "communication.settings.view",
    label: "Communication - Paramètres - Voir",
  },
  COMMUNICATION_SETTINGS_EDIT: {
    apiKey: "communication.settings.edit",
    label: "Communication - Paramètres - Éditer",
  },
  TRAININGS_ACCESS: { apiKey: "trainings.access", label: "Formations - Accès module" },
  TRAININGS_VIEW: { apiKey: "trainings.view", label: "Formations - Voir" },
  TRAININGS_EDIT: { apiKey: "trainings.edit", label: "Formations - Gérer" },
  CUSTOMERS_ACCESS: { apiKey: "customers.access", label: "Clients - Accès module" },
  CUSTOMERS_VIEW: { apiKey: "customers.view", label: "Clients - Voir" },
  CUSTOMERS_EDIT: { apiKey: "customers.edit", label: "Clients - Suppression client" },
  CUSTOMERS_PROFILE_VIEW: { apiKey: "customers.profile.view", label: "Clients - Profils - Voir" },
  CUSTOMERS_PROFILE_EDIT: { apiKey: "customers.profile.edit", label: "Clients - Profils - Éditer" },
  CUSTOMERS_TRAININGS_VIEW: {
    apiKey: "customers.trainings.view",
    label: "Clients - Formations - Voir",
  },
  CUSTOMERS_TRAININGS_EDIT: {
    apiKey: "customers.trainings.edit",
    label: "Clients - Formations - Éditer",
  },
  CUSTOMERS_EXCURSIONS_VIEW: {
    apiKey: "customers.excursions.view",
    label: "Clients - Sorties - Voir",
  },
  CUSTOMERS_PRODUCTS_VIEW: {
    apiKey: "customers.products.view",
    label: "Clients - Produits - Voir",
  },
  CUSTOMERS_PRODUCTS_EDIT: {
    apiKey: "customers.products.edit",
    label: "Clients - Produits - Éditer",
  },
  CUSTOMERS_QUALIFICATIONS_VIEW: {
    apiKey: "customers.qualifications.view",
    label: "Clients - Qualifications - Voir",
  },
  CUSTOMERS_QUALIFICATIONS_EDIT: {
    apiKey: "customers.qualifications.edit",
    label: "Clients - Qualifications - Éditer",
  },
  EQUIPMENT_ACCESS: { apiKey: "equipment.access", label: "Équipements - Accès module" },
  EQUIPMENT_VIEW: { apiKey: "equipment.view", label: "Équipements - Voir" },
  EQUIPMENT_EDIT: { apiKey: "equipment.edit", label: "Équipements - Gérer" },
  EQUIPMENT_MODELS_VIEW: {
    apiKey: "equipment.models.view",
    label: "Équipements - Modèles - Voir",
  },
  EQUIPMENT_MODELS_EDIT: {
    apiKey: "equipment.models.edit",
    label: "Équipements - Modèles - Gérer",
  },
  EQUIPMENT_SCAN_VIEW: {
    apiKey: "equipment.scan.view",
    label: "Équipements - Scanner - Voir",
  },
  EQUIPMENT_SCAN_EDIT: {
    apiKey: "equipment.scan.edit",
    label: "Équipements - Scanner - Éditer",
  },
  STATS_ACCESS: { apiKey: "stats.access", label: "Statistiques - Accès module" },
  STATS_GENERAL_VIEW: { apiKey: "stats.general.view", label: "Statistiques - Général - Voir" },
  STATS_INSTRUCTORS_VIEW: {
    apiKey: "stats.instructors.view",
    label: "Statistiques - Encadrants - Voir",
  },
  LEAVE_ACCESS: { apiKey: "leave.access", label: "RH - Accès module" },
  PLANNING_ACCESS: { apiKey: "planning.access", label: "Planning - Accès module" },
  PLANNING_ME_VIEW: { apiKey: "planning.me.view", label: "Planning - Moi - Voir" },
  PLANNING_COMPANY_VIEW: { apiKey: "planning.company.view", label: "Planning - Ma société - Voir" },
  PLANNING_ALL_VIEW: { apiKey: "planning.all.view", label: "Planning - Tout le monde - Voir" },
  PLANNING_BOOKING_ALL_VIEW: {
    apiKey: "planning.booking.all.view",
    label: "Planning - Prestations - Tout le monde - Voir",
  },
  PLANNING_BOOKING_COMPANY_VIEW: {
    apiKey: "planning.booking.company.view",
    label: "Planning - Prestations - Ma société - Voir",
  },
  PLANNING_BOOKING_ME_VIEW: {
    apiKey: "planning.booking.me.view",
    label: "Planning - Prestations - Moi - Voir",
  },
  PLANNING_BOOKING_EDIT: {
    apiKey: "planning.booking.edit",
    label: "Planning - Prestations - Éditer",
  },
  LEAVE_CREATE: { apiKey: "leave.create", label: "RH - Créer une demande" },
  LEAVE_VALIDATE: { apiKey: "leave.validate", label: "RH - Valider" },
  LEAVE_MANAGE_BALANCES: { apiKey: "leave.manage_balances", label: "RH - Gérer les soldes" },
  LEAVE_TYPES_VIEW: { apiKey: "leave.types.view", label: "RH - Types de congés - Voir" },
  LEAVE_TYPES_EDIT: { apiKey: "leave.types.edit", label: "RH - Types de congés - Éditer" },
  EVENTS_ACCESS: { apiKey: "events.access", label: "Événements - Accès module" },
  EVENTS_VIEW: { apiKey: "events.view", label: "Événements - Voir" },
  EVENTS_EDIT: { apiKey: "events.edit", label: "Événements - Gérer" },
  EXCURSIONS_ACCESS: { apiKey: "excursions.access", label: "Sorties - Accès module" },
  EXCURSIONS_VIEW: { apiKey: "excursions.view", label: "Sorties - Voir" },
  EXCURSIONS_EDIT: { apiKey: "excursions.edit", label: "Sorties - Gérer" },
  EXCURSIONS_SEND_SMS: { apiKey: "excursions.send_sms", label: "Sorties - Envoyer SMS" },
  BILLING_ACCESS: { apiKey: "billing.access", label: "Produits - Accès module" },
  BILLING_CATALOGUE_VIEW: {
    apiKey: "billing.catalogue.view",
    label: "Produits - Catalogue - Voir",
  },
  BILLING_CATALOGUE_EDIT: {
    apiKey: "billing.catalogue.edit",
    label: "Produits - Catalogue - Éditer",
  },
  BILLING_COUNTERS_VIEW: { apiKey: "billing.counters.view", label: "Produits - Compteurs - Voir" },
  BILLING_COUNTERS_EDIT: {
    apiKey: "billing.counters.edit",
    label: "Produits - Compteurs - Éditer",
  },
  RENTAL_ACCESS: { apiKey: "rental.access", label: "Location - Accès module" },
  RENTAL_VIEW: { apiKey: "rental.view", label: "Location - Voir" },
  RENTAL_EDIT: { apiKey: "rental.edit", label: "Location - Gérer" },
  RENTAL_CATALOGUE_VIEW: {
    apiKey: "rental.catalogue.view",
    label: "Location - Catalogue - Voir",
  },
  RENTAL_CATALOGUE_EDIT: {
    apiKey: "rental.catalogue.edit",
    label: "Location - Catalogue - Éditer",
  },
} as const;

export type PermissionKey = keyof typeof PERMISSIONS_MAP;
export type PermissionEntry = (typeof PERMISSIONS_MAP)[PermissionKey];
export type ApiPermissionKey = string;

/** Users list / profile sidebar tile (with `USERS_ACCESS`). */
export const USERS_SIDEBAR_LIST_KEYS: PermissionKey[] = [
  "USERS_ALL_VIEW",
  "USERS_COMPANY_VIEW",
  "USERS_OWN_VIEW",
  "USERS_OWN_EDIT",
];

/** Match `customers.profile.view`-backed flows; editors with only `customers.profile.edit` may still open ProfileForm locally. */
export const CUSTOMERS_LIST_ROW_PROFILE_KEYS: PermissionKey[] = [
  "CUSTOMERS_PROFILE_VIEW",
  "CUSTOMERS_PROFILE_EDIT",
];

/**
 * `CustomerItem` — bouton Formations (`CustomerTrainingsModal`).
 * Matches API dives/follow-up read: `trainings.view`, `customers.view`, `customers.trainings.view`, `customers.trainings.edit`.
 */
export const CUSTOMERS_LIST_ROW_TRAININGS_KEYS: PermissionKey[] = [
  "TRAININGS_VIEW",
  "CUSTOMERS_VIEW",
  "CUSTOMERS_TRAININGS_VIEW",
  "CUSTOMERS_TRAININGS_EDIT",
];

/** Follow-up sheet and dives write (API `canEditDivesAndFollowUpSheets`). */
export const FOLLOWUP_EDIT_KEYS: PermissionKey[] = ["TRAININGS_EDIT", "CUSTOMERS_TRAININGS_EDIT"];

/** Follow-up sheet and dives read (API `canViewDivesAndFollowUpSheets`, editors implicitly read). */
export const FOLLOWUP_VIEW_KEYS: PermissionKey[] = [
  "TRAININGS_VIEW",
  "CUSTOMERS_VIEW",
  "CUSTOMERS_TRAININGS_VIEW",
  ...FOLLOWUP_EDIT_KEYS,
];

/** `CustomerItem` — bouton Sorties (`CustomerExcursionsModal`). API: `customers.excursions.view`. */
export const CUSTOMERS_LIST_ROW_EXCURSIONS_KEYS: PermissionKey[] = ["CUSTOMERS_EXCURSIONS_VIEW"];

/**
 * Customers module only — `CustomerItem` bouton Produits (`CustomerProductsModal`). Do not mix with `billing.*`; see `useCustomersModulePermissions`.
 */
export const CUSTOMERS_LIST_ROW_PRODUCTS_KEYS: PermissionKey[] = [
  "CUSTOMERS_PRODUCTS_VIEW",
  "CUSTOMERS_PRODUCTS_EDIT",
];

/** Customer row delete in desync (`customers.edit`). */
export const CUSTOMERS_LIST_ROW_DELETE_KEYS: PermissionKey[] = ["CUSTOMERS_EDIT"];

/** Load excursion bookings on the planning calendar when any of these is granted. */
export const PLANNING_EXCURSION_BOOKINGS_KEYS: PermissionKey[] = [
  "PLANNING_ACCESS",
  "PLANNING_ME_VIEW",
  "PLANNING_COMPANY_VIEW",
  "PLANNING_ALL_VIEW",
  "LEAVE_VALIDATE",
  "EXCURSIONS_VIEW",
  "EXCURSIONS_EDIT",
  "PLANNING_BOOKING_ALL_VIEW",
  "PLANNING_BOOKING_COMPANY_VIEW",
  "PLANNING_BOOKING_ME_VIEW",
];

/** Sidebar « Prestations » : au moins une vue prestation planning. */
export const PLANNING_BOOKING_SIDEBAR_KEYS: PermissionKey[] = [
  "PLANNING_BOOKING_ALL_VIEW",
  "PLANNING_BOOKING_COMPANY_VIEW",
  "PLANNING_BOOKING_ME_VIEW",
];

/** Sidebar billing: at least catalogue or counters view. */
export const BILLING_CATALOGUE_SIDEBAR_KEYS: PermissionKey[] = [
  "BILLING_CATALOGUE_VIEW",
  "BILLING_CATALOGUE_EDIT",
];

/** Sidebar rental catalogue (sous-page Location dans Produits). */
export const RENTAL_CATALOGUE_SIDEBAR_KEYS: PermissionKey[] = [
  "RENTAL_CATALOGUE_VIEW",
  "RENTAL_CATALOGUE_EDIT",
];

/** Sidebar rental (page Location /rental). */
export const RENTAL_SIDEBAR_KEYS: PermissionKey[] = ["RENTAL_VIEW", "RENTAL_EDIT"];

/** Company / all planning scope: filter bar and optional leave UserID query. */
export const PLANNING_FILTER_MENU_KEYS: PermissionKey[] = [
  "PLANNING_COMPANY_VIEW",
  "PLANNING_ALL_VIEW",
];

/** @deprecated Use PLANNING_FILTER_MENU_KEYS */
export const PLANNING_USER_FILTER_KEYS = PLANNING_FILTER_MENU_KEYS;

export const PERMISSION_SECTIONS: {
  label: string;
  keys: PermissionKey[];
  showOnlyWhenDesync?: boolean;
}[] = [
  { label: "Administration", keys: ["ADMIN"] },
  {
    label: "Sorties",
    keys: ["EXCURSIONS_ACCESS", "EXCURSIONS_VIEW", "EXCURSIONS_EDIT", "EXCURSIONS_SEND_SMS"],
  },
  {
    label: "Clients",
    keys: [
      "CUSTOMERS_ACCESS",
      "CUSTOMERS_VIEW",
      "CUSTOMERS_EDIT",
      "CUSTOMERS_PROFILE_VIEW",
      "CUSTOMERS_PROFILE_EDIT",
      "CUSTOMERS_TRAININGS_VIEW",
      "CUSTOMERS_TRAININGS_EDIT",
      "CUSTOMERS_EXCURSIONS_VIEW",
      "CUSTOMERS_PRODUCTS_VIEW",
      "CUSTOMERS_PRODUCTS_EDIT",
      "CUSTOMERS_QUALIFICATIONS_VIEW",
      "CUSTOMERS_QUALIFICATIONS_EDIT",
    ],
  },
  {
    label: "Formations",
    keys: ["TRAININGS_ACCESS", "TRAININGS_VIEW", "TRAININGS_EDIT"],
  },
  {
    label: "Équipements",
    keys: [
      "EQUIPMENT_ACCESS",
      "EQUIPMENT_VIEW",
      "EQUIPMENT_EDIT",
      "EQUIPMENT_MODELS_VIEW",
      "EQUIPMENT_MODELS_EDIT",
      "EQUIPMENT_SCAN_VIEW",
      "EQUIPMENT_SCAN_EDIT",
    ],
  },
  {
    label: "Planning",
    keys: [
      "PLANNING_ACCESS",
      "PLANNING_ME_VIEW",
      "PLANNING_COMPANY_VIEW",
      "PLANNING_ALL_VIEW",
      "PLANNING_BOOKING_ALL_VIEW",
      "PLANNING_BOOKING_COMPANY_VIEW",
      "PLANNING_BOOKING_ME_VIEW",
      "PLANNING_BOOKING_EDIT",
    ],
  },
  {
    label: "RH",
    keys: [
      "LEAVE_ACCESS",
      "LEAVE_CREATE",
      "LEAVE_VALIDATE",
      "LEAVE_MANAGE_BALANCES",
      "LEAVE_TYPES_VIEW",
      "LEAVE_TYPES_EDIT",
    ],
  },
  {
    label: "Produits",
    showOnlyWhenDesync: true,
    keys: [
      "BILLING_ACCESS",
      "BILLING_CATALOGUE_VIEW",
      "BILLING_CATALOGUE_EDIT",
      "BILLING_COUNTERS_VIEW",
      "BILLING_COUNTERS_EDIT",
    ],
  },
  {
    label: "Location",
    keys: [
      "RENTAL_ACCESS",
      "RENTAL_VIEW",
      "RENTAL_EDIT",
      "RENTAL_CATALOGUE_VIEW",
      "RENTAL_CATALOGUE_EDIT",
    ],
  },
  {
    label: "Statistiques",
    keys: ["STATS_ACCESS", "STATS_GENERAL_VIEW", "STATS_INSTRUCTORS_VIEW"],
  },
  {
    label: "Événements",
    keys: ["EVENTS_ACCESS", "EVENTS_VIEW", "EVENTS_EDIT"],
  },
  {
    label: "Utilisateurs",
    keys: [
      "USERS_ACCESS",
      "USERS_ALL_VIEW",
      "USERS_ALL_EDIT",
      "USERS_COMPANY_VIEW",
      "USERS_COMPANY_EDIT",
      "USERS_ROLES_VIEW",
      "USERS_ROLES_EDIT",
      "USERS_DOCUMENTS_VIEW",
      "USERS_DOCUMENTS_EDIT",
      "USERS_OWN_VIEW",
      "USERS_OWN_EDIT",
    ],
  },
  {
    label: "Identification du Centre",
    keys: [
      "CENTRE_ACCESS",
      "CENTRE_INFO_VIEW",
      "CENTRE_INFO_EDIT",
      "CENTRE_DEVICES_VIEW",
      "CENTRE_DEVICES_PAIR",
      "CENTRE_DEVICES_REVOKE",
    ],
  },
  {
    label: "Communication",
    keys: [
      "COMMUNICATION_ACCESS",
      "COMMUNICATION_MAIL_TEMPLATES_VIEW",
      "COMMUNICATION_MAIL_TEMPLATES_EDIT",
      "COMMUNICATION_SMS_TEMPLATES_VIEW",
      "COMMUNICATION_SMS_TEMPLATES_EDIT",
      "COMMUNICATION_GOOGLE_GROUPS_VIEW",
      "COMMUNICATION_GOOGLE_GROUPS_EDIT",
      "COMMUNICATION_SETTINGS_VIEW",
      "COMMUNICATION_SETTINGS_EDIT",
    ],
  },
];

export type ApiPermissionSectionPreview = { label: string; keys: string[] };

/** Group permission API keys by PERMISSION_SECTIONS (same order as PermissionsPicker); unknown keys under "Autres". */
export function groupApiPermissionsByModule(permissions: string[]): ApiPermissionSectionPreview[] {
  if (!permissions.length) return [];
  const permSet = new Set(permissions);
  const seen = new Set<string>();
  const groups: ApiPermissionSectionPreview[] = [];
  for (const section of PERMISSION_SECTIONS) {
    const keys: string[] = [];
    for (const k of section.keys) {
      const apiKey = PERMISSIONS_MAP[k].apiKey;
      if (permSet.has(apiKey) && !seen.has(apiKey)) {
        seen.add(apiKey);
        keys.push(apiKey);
      }
    }
    if (keys.length > 0) {
      groups.push({ label: section.label, keys });
    }
  }
  const rest = permissions.filter((p) => !seen.has(p)).sort((a, b) => a.localeCompare(b, "fr"));
  if (rest.length > 0) {
    groups.push({ label: "Autres", keys: rest });
  }
  return groups;
}

/** Flat list order (module order, then unknown keys). */
export function sortApiPermissionsByModule(permissions: string[]): string[] {
  return groupApiPermissionsByModule(permissions).flatMap((g) => g.keys);
}

export function getApiPermissionLabel(key: string): string {
  const perm = Object.values(PERMISSIONS_MAP).find((p) => p.apiKey === key);
  return perm?.label ?? key;
}

export const Permission = Object.fromEntries(
  (Object.keys(PERMISSIONS_MAP) as PermissionKey[]).map((k) => [k, k]),
) as Record<PermissionKey, PermissionKey>;
